/* eslint-disable */

import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { message } from "antd";

import Utils from "../../Utils";

import { IUseDistributorData } from "./IUseDistributorData";
import { DefaultValue, DistributorData } from "../../Models";

export const useDistributorData = ({
	translations,
	distributorsAPI,
	unlockNextStep,
	contractAPI
}: IUseDistributorData) => {
  	const [searchParams, _] = useSearchParams();

  	const [loading, setLoading] = useState<boolean>(false);
	const [distributorData, setDistributorData] = useState<DistributorData>({
		idContract: 0,
		name: "",
		lastName: "",
		secondLastName: "",
		email: "",
		type: "distributor",
		phonePrefix: "",
		phoneNumber: "",
		emailToNotify: ""
	});
	const [defaultValues, setDefaultValues] = useState<DefaultValue[]>([]);
	const [contractId, setContractId] = useState<number>(0);
	const [errors, setErrors] = useState<any>({
		name: false,
		lastName: false,
		email: false,
		phonePrefix: false,
		phoneNumber: false,
	});

	useEffect(() => {
		if (searchParams.has("ContractId")) {
			configureInitialData(Number(searchParams.get("ContractId")));
		}
		else if (searchParams.has("hash")) {
			const hash = searchParams.get("hash");
			const getContractIdByHash = async (hash: string) => {
				return await contractAPI.getContractByHash(hash)
					.then((res: any) => {
						if (res.success) {
							configureInitialData(Number(res.data));
						}
					});
			};

			getContractIdByHash(hash!);
		}
	}, [translations]);

	const handleChangeData = (_: number) => (e: any) => {
		const { name, value } = e.target;
		if (!!errors[name]) {
			setErrors((prevState: any) => ({
				...prevState,
				[name]: false,
			}));
		}
		let dist = { ...(distributorData as any) };
		if (name === "email") {
			dist.emailToNotify = value;
		}
		dist[name] = value;
		setDistributorData(dist);
	};

	const configureInitialData = (ContractId: number) => {
		setLoading(true);
		setContractId(ContractId);
		distributorsAPI.getDefaultValuesDistributor(ContractId)
			.then((resp: any) => {
				if (resp.success && resp.data) {
					const newDefaultValues: DefaultValue[] = resp.data;
					setDefaultValues(newDefaultValues);
					distributorsAPI.getDistributors(ContractId)
						.then((resp: any) => {
							let newDistributorData: DistributorData;
							if (resp.success && resp.data) {
								newDistributorData = resp.data;
							} else {
								newDistributorData = { ...distributorData, idContract: ContractId };
								newDefaultValues.forEach((defVal: DefaultValue) => {
									if (newDistributorData.hasOwnProperty(defVal.field) && defVal.value) {
										(newDistributorData as any)[defVal.field] = defVal.value;
									}
								});
							}
							
							setDistributorData(newDistributorData);
							setLoading(false);
						})
						.catch((err: any) => {
							console.log(err);
						});
				}
			});
	};

	const validateData = (data: any) => {
		const { name, lastName, email, phoneNumber, phonePrefix, emailToNotify } = data;
		const updatedErrors: any = {
			name: !name && !defaultValues.some(defVal => defVal.field === "name"),
			lastName: !lastName && !defaultValues.some(defVal => defVal.field === "lastName"),
			email: (!email || !Utils.validate("email", email)) && !defaultValues.some(defVal => defVal.field === "email"),
			phonePrefix: !phonePrefix && !defaultValues.some(defVal => defVal.field === "phonePrefix"),
			phoneNumber: !phoneNumber && !defaultValues.some(defVal => defVal.field === "phoneNumber"),
		};

		setErrors((prevState: any) => ({ ...prevState, ...updatedErrors }));
		let notifEmail = validateEmails(emailToNotify.replace(/ /g, ""));
		let allErrors = Object.values(updatedErrors).some(Boolean);
		return (!allErrors && notifEmail);
	};

	const validateEmails = (email: string) => {
		const emails = email.split(";");
		if(emails.length === 1 && emails[0] === ""){
			return true;
		}
		const invalidEmails = emails.filter((e) => !Utils.validate("email", e));
		if (invalidEmails.length > 0) {
			message.error(translations.invalidEmails);
			return false;
		}
		return true;
	};

	const saveData = async () => {
		setLoading(true);
		if (validateData(distributorData)) {
			distributorData.emailToNotify = distributorData.emailToNotify.replace(/ /g, "");
			if (distributorData.id === 0 || !distributorData.id) {
				await distributorsAPI.saveDistributors(distributorData)
					.then((resp: any) => {
						if (resp.success) {
							message.success(translations.datosGuardados);
							unlockNextStep(contractId);
						} else {
							message.error(translations.messageError);
						}
						setLoading(false);
					})
					.catch((err: any) => {
						console.log(err);
					});
				setLoading(false);
			} else {
				await distributorsAPI.updateDistributors(distributorData)
					.then((resp: any) => {
						if (resp.success) {
							message.success(translations.datosGuardados);
							unlockNextStep(contractId);
						} else {
							message.error(translations.messageError);
						}
					});
			}
		} 
		setLoading(false);
	};

	return {
		loading,
		errors,
		distributorData,
		contractId,
		defaultValues,
		handleChangeData,
		saveData,
	};
};
